'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _container = require('@hixme-ui/container');

var _container2 = _interopRequireDefault(_container);

var _icon = require('@hixme-ui/icon');

var _icon2 = _interopRequireDefault(_icon);

var _text = require('@hixme-ui/text');

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CloseButton = function (_Component) {
  (0, _inherits3.default)(CloseButton, _Component);

  function CloseButton() {
    (0, _classCallCheck3.default)(this, CloseButton);
    return (0, _possibleConstructorReturn3.default)(this, (CloseButton.__proto__ || (0, _getPrototypeOf2.default)(CloseButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(CloseButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onClick = _props.onClick,
          label = _props.label,
          noLabel = _props.noLabel,
          iconSize = _props.iconSize;


      return _react2.default.createElement(
        _container2.default,
        { flexColumn: true, alignCenter: true, onClick: onClick, padding: '0' },
        _react2.default.createElement(
          _text2.default,
          { cursor: 'pointer' },
          _react2.default.createElement(_icon2.default, { xCircle: true, size: iconSize, light: true })
        ),
        noLabel ? null : _react2.default.createElement(
          _text2.default,
          { light: true, cursor: 'pointer' },
          label
        )
      );
    }
  }]);
  return CloseButton;
}(_react.Component);

// hixme-ui


CloseButton.displayName = 'hui:CloseButton';
CloseButton.huiName = 'CloseButton';
CloseButton.propTypes = {
  iconSize: _propTypes2.default.number,
  onClick: _propTypes2.default.func,
  label: _propTypes2.default.string,
  noLabel: _propTypes2.default.bool
};
CloseButton.defaultProps = {
  iconSize: 1.8,
  onClick: function onClick() {
    return null;
  },
  label: 'CLOSE',
  noLabel: false
};
exports.default = CloseButton;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../close-button/lib/index.js
// module id = 86
// module chunks = 0